import styled from "styled-components";

import { Primary, Black, DarkGrey } from "src/styles/color";

import device from "src/styles/device";
import font from "src/styles/font";

const S = {};

/* Intentionally set this margin top and bottom together to take advantage of 'margin collapsed. */
// const Container = styled.div`
//   width: 100%;
//   margin: 40px 0;
//   padding: 0 100px;
//   position: relative;

//   @media ${device.tabletL} {
//     margin: 25px 0;
//     padding: 0 40px;
//   }

//   @media ${device.mobileL} {
//     margin: 25px 0;
//     padding: 0 20px;
//   }
// `

S.LabelSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`;

S.LabelHeader = styled.div`
  margin-bottom: 42px;

  @media ${device.tabletL} {
    margin-bottom: 32px;
  }

  @media ${device.mobileL} {
    justify-content: flex-start;
    margin-bottom: 24px;
  }
`;

S.Header = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

S.Title = styled.span`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 500;
  line-height: 30px;
  color: ${Black};
  text-align: left;

  ::before {
    content: "";
    width: 4px;
    color: ${Primary};
    background: ${Primary};
    display: ${(props) => (props.displayTitleLabel ? "inline-block" : "none")};
    height: 32px;
    margin-right: 15px;
    border-radius: 3px;
  }

  /* @media ${device.tablet} {
    font-size: 1.25rem;
  } */
`;

S.SubHeader = styled.div`
  margin-top: 16px;
  position: relative;
  max-width: 350px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

S.Description = styled.span`
  font-size: ${font.size.sm};
  font-weight: 300;
  color: ${DarkGrey};
  white-space: nowrap;

  @media ${device.mobileL} {
    text-align: left;
  }
`;

const LabelSection = ({
  title,
  titleStyle,
  headerStyle,
  description,
  descIcon,
  actionMenu,
  children,
  className,
  style,
}) => {
  return (
    <S.LabelSection className={className} style={style}>
      <S.LabelHeader style={headerStyle}>
        <S.Header>
          <S.Title
            style={titleStyle} // if titleStyle is defined, override default style
            displayTitleLabel={typeof title === "string"} // if title is string, display title label
          >
            {title}
            {/* will refactor this title by using typography component as props later */}
          </S.Title>
          {actionMenu ? actionMenu() : null}
        </S.Header>
        {description &&
          (typeof description === "string" ? (
            <S.SubHeader>
              <S.Description>{description}</S.Description>
              {descIcon ? descIcon : null}
            </S.SubHeader>
          ) : (
            description
          ))}
      </S.LabelHeader>
      {children}
    </S.LabelSection>
  );
};

export default LabelSection;
